
<div class="row card-block order-form">
  <div class="col" printable>
    <div class="row mb-5">
      <div class="col">
        <div class="row">
          <div class="col-sm-12 col-md-12">
            <h3>HP Order Form</h3>
            <div class="links"><a href="javascript:void(0);" printOnClick>Print</a></div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 header">
            <h6>Order Name</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>HP Customer Number (SANDY)</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Customer Requested Delivery Date</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-4"><span>{{ orderForm.name }}</span></div>
          <div class="col-sm-4 col-md-4">
            <micro-input [allowEditing]="allowEditing.erpAccount" [(ngModel)]="orderForm.header.erpAccount" [paramName]="'erpAccount'" [saveUrl]="'/api/projects/update-field?id=' + orderForm.projectId" (error)="forwardError($event)"></micro-input>
          </div>
          <div class="col-sm-4 col-md-4">
            <micro-date [allowEditing]="allowEditing.requestedDeliveryDate" [(ngModel)]="orderForm.header.requestedDeliveryDate" [mutation]="microFormMutators.requestedDeliveryDate" (error)="forwardError($event)"></micro-date>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 header">
            <h6>Bill To Contact</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Customer Contact</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Installation Contact</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-4">
            <div class="row">
              <div class="col-sm-12"><span>
                  {{ orderForm.header.billToContact.firstName }} {{ orderForm.header.billToContact.lastName }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.billToContact.emailAddress }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.billToContact.phoneNumber }}</span></div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4">
            <div class="row">
              <div class="col-sm-12"><span>
                  {{ orderForm.header.deliveryContact.firstName }} {{ orderForm.header.deliveryContact.lastName }}</span>
                <div class="links" *ngIf="allowEditing.deliveryContact"><a href="javascript:void(0)" (click)="editDeliveryContact()"><span class="oi oi-pencil oi-smaller"></span> Edit</a></div>
              </div>
              <div class="col-sm-12"><span>{{ orderForm.header.deliveryContact.emailAddress }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.deliveryContact.phoneNumber }}</span></div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4">
            <div class="row">
              <div class="col-sm-12"><span>
                  {{ orderForm.header.installationContact.firstName }} {{ orderForm.header.installationContact.lastName }}</span>
                <div class="links" *ngIf="allowEditing.installationContact"><a href="javascript:void(0)" (click)="editInstallationContact()"><span class="oi oi-pencil oi-smaller"></span> Edit</a></div>
              </div>
              <div class="col-sm-12"><span>{{ orderForm.header.installationContact.emailAddress }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.installationContact.phoneNumber }}</span></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 header">
            <h6>Bill To Address</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Customer Physical Address</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Ship To Address</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-4">
            <div class="row">
              <div class="col-sm-12"><span>{{ orderForm.header.billToAddress.name1 }}</span></div>
              <div class="col-sm-12" [hidden]="!orderForm.header.billToAddress.name2"><span>{{ orderForm.header.billToAddress.name2 }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.billToAddress.line1 }}</span></div>
              <div class="col-sm-12" [hidden]="!orderForm.header.billToAddress.line2"><span>{{ orderForm.header.billToAddress.line2 }}</span></div>
              <div class="col-sm-12"><span>
                  {{ orderForm.header.billToAddress.city }}{{ orderForm.header.billToAddress.region ? ',' : '' }}
                   {{ orderForm.header.billToAddress.region| region }}
                   {{ orderForm.header.billToAddress.postalCode }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.billToAddress.country | country }}</span></div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4">
            <div class="row">
              <div class="col-sm-12"><span>{{ orderForm.header.siteAddress.name1 }}</span>
                <div class="links" *ngIf="allowEditing.siteAddress"><a href="javascript:void(0)" (click)="editSiteAddress()"><span class="oi oi-pencil oi-smaller"></span>Edit</a></div>
              </div>
              <div class="col-sm-12" [hidden]="!orderForm.header.siteAddress.name2"><span>{{ orderForm.header.siteAddress.name2 }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.siteAddress.line1 }}</span></div>
              <div class="col-sm-12" [hidden]="!orderForm.header.siteAddress.line2"><span>{{ orderForm.header.siteAddress.line2 }}</span></div>
              <div class="col-sm-12"><span>
                  {{ orderForm.header.siteAddress.city }}{{ orderForm.header.siteAddress.region ? ',' : '' }}
                   {{ orderForm.header.siteAddress.region | region }}
                   {{ orderForm.header.siteAddress.postalCode }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.siteAddress.country | country }}</span></div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4" *ngIf="!orderForm.header.shippingDestination || orderForm.header.shippingDestination === 'CUSTOMER_SITE'">
            <div class="row">
              <div class="col-sm-12"><span>{{ orderForm.header.siteAddress.name1 }}</span></div>
              <div class="col-sm-12" [hidden]="!orderForm.header.siteAddress.name2"><span>{{ orderForm.header.siteAddress.name2 }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.siteAddress.line1 }}</span></div>
              <div class="col-sm-12" [hidden]="!orderForm.header.siteAddress.line2"><span>{{ orderForm.header.siteAddress.line2 }}</span></div>
              <div class="col-sm-12"><span>
                  {{ orderForm.header.siteAddress.city }}{{ orderForm.header.siteAddress.region ? ',' : '' }}
                   {{ orderForm.header.siteAddress.region | region }}
                   {{ orderForm.header.siteAddress.postalCode }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.siteAddress.country | country }}</span></div>
            </div>
          </div>
          <div class="col-sm-4 col-md-4" *ngIf="orderForm.header.shippingDestination &amp;&amp; orderForm.header.shippingDestination !== 'CUSTOMER_SITE'">
            <div class="row">
              <div class="col-sm-12"><span>{{ orderForm.header.configurationAddress.name1 }}</span>
                <div class="links" *ngIf="allowEditing.configurationAddress"><a href="javascript:void(0)" (click)="editConfigurationAddress()"><span class="oi oi-pencil oi-smaller"></span>Edit</a></div>
              </div>
              <div class="col-sm-12" [hidden]="!orderForm.header.configurationAddress.name2"><span>{{ orderForm.header.configurationAddress.name2 }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.configurationAddress.line1 }}</span></div>
              <div class="col-sm-12" [hidden]="!orderForm.header.configurationAddress.line2"><span>{{ orderForm.header.configurationAddress.line2 }}</span></div>
              <div class="col-sm-12"><span>
                  {{ orderForm.header.configurationAddress.city }}{{ orderForm.header.configurationAddress.region ? ',' : '' }}
                   {{ orderForm.header.configurationAddress.region | region }}
                   {{ orderForm.header.configurationAddress.postalCode }}</span></div>
              <div class="col-sm-12"><span>{{ orderForm.header.configurationAddress.country | country }}</span></div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 header">
            <h6>DART Deal ID(s)</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Shipping Destination</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Delivery Method</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4"><span>{{ orderForm.header.dealIds }}</span></div>
          <div class="col-sm-4">
            <micro-select class="extra-spacing" [allowEditing]="allowEditing.shippingDestination" [(ngModel)]="orderForm.header.shippingDestination" [items]="shippingDestinationValues" [mutation]="microFormMutators.shippingDestination" (error)="forwardError($event)"></micro-select>
          </div>
          <div class="col-sm-4">
            <micro-select class="extra-spacing" [allowEditing]="allowEditing.deliveryMethod" [(ngModel)]="orderForm.header.deliveryMethod" [items]="deliveryMethodValues" [mutation]="microFormMutators.deliveryMethod" (error)="forwardError($event)"></micro-select>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-9 header">
            <h6>SAL/VAL Number(s)</h6>
          </div>
          <div class="col-sm-3 header">
            <h6>OPG Number</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-9">
            <micro-textarea [allowEditing]="allowEditing.salValNumber" [(ngModel)]="orderForm.header.salValNumber" [mutation]="microFormMutators.salValNumber" (error)="forwardError($event)"></micro-textarea>
          </div>
          <div class="col-sm-3">
            <micro-input [allowEditing]="allowEditing.opgNumber" [(ngModel)]="orderForm.header.opgNumber" [paramName]="'opgNumber'" [saveUrl]="'/api/projects/update-field?id=' + orderForm.projectId" (error)="forwardError($event)"></micro-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3 header">
            <h6>Ship Complete</h6>
          </div>
          <div class="col-sm-3 header">
            <h6>Floor Level</h6>
          </div>
          <div class="col-sm-3 header">
            <h6>Estimated Delivery Date</h6>
          </div>
          <div class="col-sm-3 header">
            <h6>Estimated Hardware Order Date</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">
            <micro-select class="extra-spacing" [allowEditing]="allowEditing.shipCompleted" [(ngModel)]="orderForm.header.shipCompleted" [items]="{&quot;true&quot;: &quot;Yes&quot;, &quot;false&quot;: &quot;No&quot;}" [mutation]="microFormMutators.shipCompleted" (error)="forwardError($event)"></micro-select>
          </div>
          <div class="col-sm-3">
            <micro-input [allowEditing]="allowEditing.floorLevel" [(ngModel)]="orderForm.header.floorLevel" [mutation]="microFormMutators.floorLevel" (error)="forwardError($event)"></micro-input>
          </div>
          <div class="col-sm-3">
            <micro-date [allowEditing]="allowEditing.estimatedDeliveryDate" [(ngModel)]="orderForm.header.estimatedDeliveryDate" [mutation]="microFormMutators.estimatedDeliveryDate" (error)="forwardError($event)"></micro-date>
          </div>
          <div class="col-sm-3">
            <micro-date [allowEditing]="allowEditing.estimatedHardwareOrderDate" [(ngModel)]="orderForm.header.estimatedHardwareOrderDate" [mutation]="microFormMutators.estimatedHardwareOrderDate" (error)="forwardError($event)"></micro-date>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 header">
            <h6>Extra Pricing Information</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Reseller Information</h6>
          </div>
          <div class="col-sm-4 header">
            <h6>Reseller Instructions</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <micro-textarea [allowEditing]="allowEditing.extraPricingInformation" [(ngModel)]="orderForm.header.extraPricingInformation" [mutation]="microFormMutators.extraPricingInformation" (error)="forwardError($event)"></micro-textarea>
          </div>
          <div class="col-sm-4">
            <micro-textarea [allowEditing]="allowEditing.resellerInformation" [(ngModel)]="orderForm.header.resellerInformation" [mutation]="microFormMutators.resellerInformation" (error)="forwardError($event)"></micro-textarea>
          </div>
          <div class="col-sm-4">
            <micro-textarea [allowEditing]="allowEditing.resellerInstructions" [(ngModel)]="orderForm.header.resellerInstructions" [mutation]="microFormMutators.resellerInstructions" (error)="forwardError($event)"></micro-textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 header">
            <h6>Source documentation link (DealSource or MAD)</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <micro-input [showAsHyperlink]="true" [linkTarget]="'_blank'" [allowEditing]="allowEditing.sourceDocumentationLink" [(ngModel)]="orderForm.header.sourceDocumentationLink" [mutation]="microFormMutators.sourceDocumentationLink" (error)="forwardError($event)"></micro-input>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 header">
            <h6>Delivery Information</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <micro-textarea class="extra-spacing" [allowEditing]="allowEditing.deliveryInformation" [(ngModel)]="orderForm.header.deliveryInformation" [mutation]="microFormMutators.deliveryInformation" (error)="forwardError($event)"></micro-textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 header">
            <h6>Notification Email List</h6>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <micro-input [allowEditing]="allowEditing.orderNotificationEmailList" [(ngModel)]="orderForm.header.orderNotificationEmailList" [mutation]="microFormMutators.orderNotificationEmailList" (error)="forwardError($event)"></micro-input>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="orderForm.devices">
      <div class="col">
        <div class="row">
          <div class="col-sm-12">
            <h3>Devices</h3>
            <div class="float-right" *ngIf="allowEditing.orderResults &amp;&amp; !editingOrderResults" style="margin-top: -2rem;"><a class="float-right micro-input-edit-link font-14" href="javascript:void(0)" (click)="editOrderResults();"><span class="oi oi-pencil oi-smaller"></span> Edit Order Numbers and Dates</a></div>
            <div class="float-right" *ngIf="editingOrderResults" style="margin-top: -2rem;"><span class="pr-2" style="position: relative; top: 2px;">Enter Order Numbers & Dates Below</span>
              <div class="btn-group btn-group-sm float-right">
                <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cancelOrderResults()">Cancel</button>
                <button class="btn btn-sm btn-primary" type="button" (click)="saveOrderResults()">Save</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row order-info-multi-entry-row mb-1" *ngIf="editingOrderResults">
          <div class="col-12 text-center">Bulk Order Details Update</div>
          <div class="col-2 text-right">
            <label class="form-control-label mt-1 mb-1" for="bulkOrderNumber">Order Number:</label>
          </div>
          <div class="col-3">
            <input class="form-control form-control-sm" id="bulkOrderNumber" type="text" [(ngModel)]="bulkUpdateOrderNumber">
          </div>
          <div class="col-2 text-right">
            <label class="form-control-label mt-1 mb-1" for="bulkOrderDate">Order Date:</label>
          </div>
          <div class="col-3">
            <div class="input-group input-group-sm">
              <input class="form-control form-control-sm" id="bulkOrderDate" type="text" [(ngModel)]="bulkUpdateOrderDate">
              <datepicker class="right input-group-append" [(ngModel)]="bulkUpdateOrderDate"></datepicker>
            </div>
          </div>
          <div class="col-2">
            <button class="btn btn-primary btn-sm" type="button" (click)="copyBulkOrderNumberAndDate()">Copy to All</button>
          </div>
        </div>
        <div class="row header">
          <div class="col">
            <h6>DART ID &amp; SKU</h6>
          </div>
          <div class="col">
            <h6>Preconfiguration Service Number</h6>
          </div>
          <div class="col-4">
            <h6>Description</h6>
          </div>
          <div class="col-1">
            <h6>Qty per Bundle</h6>
          </div>
          <div class="col-1">
            <h6>Total Qty</h6>
          </div>
          <div class="col text-right">
            <h6>Catalogue Price</h6>
          </div>
          <div class="col text-right">
            <h6>Extended Price</h6>
          </div>
        </div>
        <ng-container *ngFor="let device of orderForm.devices; let i = index">
          <div class="hide-on-print-preview" *ngIf="!device.indented &amp;&amp; editingOrderResults &amp;&amp; !device.multipleOrderNumbers" [ngClass]="{row: true, shaded: device.shaded, indented: true, 'order-info-entry-row': true}">
            <div class="col-2 text-right">
              <label class="form-control-label mt-1 mb-1" [attr.for]="&quot;orderNumber&quot; + i">Order Number:</label>
            </div>
            <div class="col-3">
              <input class="form-control form-control-sm" type="text" [(ngModel)]="device.orderNumber" [id]="&quot;orderNumber&quot; + i">
            </div>
            <div class="col-2 text-right">
              <label class="form-control-label mt-1 mb-1" [attr.for]="&quot;orderDate&quot; + i">Order Date:</label>
            </div>
            <div class="col-3">
              <div class="input-group input-group-sm">
                <input class="form-control form-control-sm" type="text" [(ngModel)]="device.orderDate" [id]="&quot;orderDate&quot; + i">
                <datepicker class="right input-group-append" [(ngModel)]="device.orderDate"></datepicker>
              </div>
            </div>
            <div class="col-2" *ngIf="!device.isStandaloneAccessory">
              <button class="btn btn-sm btn-outline-primary" type="button" (click)="splitDevice(i)">Split Quantity</button>
            </div>
          </div>
          <div *ngIf="!device.indented &amp;&amp; editingOrderResults &amp;&amp; device.multipleOrderNumbers" [ngClass]="{row: true, shaded: device.shaded, indented: true, 'order-info-entry-row': true}">
            <div class="col-10">
              <label class="form-control-label mt-1 mb-1">Multiple order numbers or dates exist for this device, and this record must be split to change them.</label>
            </div>
            <div class="col-2" *ngIf="!device.isStandaloneAccessory">
              <button class="btn btn-sm btn-outline-primary" type="button" (click)="autoSplitDevice(i)">Split Quantity</button>
            </div>
          </div>
          <div [ngClass]="{row: true, shaded: device.shaded, indented: device.indented, bolded: !device.indented}">
            <div class="col d-block dart-id" *ngIf="!device.indented"><span>{{ device.deviceKey }}</span></div>
            <div class="col d-block sku" *ngIf="device.indented"><span>{{ device.productNumber }}</span></div>
            <div class="col" *ngIf="device.isStandaloneAccessory &amp;&amp; device.entity === &quot;Solution&quot;"><span>Accessory Only</span></div>
            <div class="col" *ngIf="!device.isStandaloneAccessory &amp;&amp; device.entity === &quot;Solution&quot;"><span>{{ device.bundleNumbers }}</span></div>
            <div class="col" *ngIf="device.entity !== &quot;Solution&quot;"><span *ngIf="device.isStandaloneAccessory">{{ device.bundleNumbers }}</span></div>
            <div class="col-4 description"><span class="d-block">{{ device.description }}</span></div>
            <div class="col-1" *ngIf="device.entity === &quot;Solution&quot;"></div>
            <div class="col-1" *ngIf="device.entity !== &quot;Solution&quot;"><span>{{ device.childrenQuantity }}</span></div>
            <div class="col-1 qty"><span>{{ device.orderQuantity || '' }}</span></div>
            <div class="col price text-right" [ngClass]="{invisible: (device.entity === 'Solution')}"><span>
                {{ device.cataloguePrice | number:'1.2-2' }} {{ orderForm.header.currency }}</span></div>
            <div class="col text-right"><span>
                {{ device.extendedPrice | number:'1.2-2' }} {{ orderForm.header.currency }}</span></div>
          </div>
          <div class="show-on-print-preview" [ngClass]="{row: true, shaded: device.shaded, indented: true}" *ngIf="!device.indented">
            <div class="col-2 text-right">
              <h6>Order Number:</h6>
            </div>
            <div class="col-1"><span>{{ device.orderNumber }}</span></div>
            <div class="col-2 text-right">
              <h6>Order Date:</h6>
            </div>
            <div class="col-2"><span>{{ device.orderDate }}</span></div>
          </div>
        </ng-container>
        <div class="row justify-content-end">
          <div class="col-1"></div>
          <div class="col"></div>
          <div class="col"></div>
          <div class="col-5"></div>
          <div class="col header text-right">Total:</div>
          <div class="bolded col text-right">
            {{ orderForm.header.orderTotal | number:'1.2-2' }} {{ orderForm.header.currency }}</div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</div>